import {FC} from 'react'

import {Locale} from '@/utils/constants'
import {Region} from '@/utils/countries'
import {Currency} from '@/utils/currency'
import {useLanguage} from '@/utils/i18n/language'

import {usePreferences} from '../context/Preferences'
import HiddenField from '../inputs/HiddenField'

type UserLocaleHiddenFields = {
  language?: Locale
  currency?: Currency
  region?: Region
  timezone?: string
}

export const UserLocaleHiddenFields: FC<UserLocaleHiddenFields> = ({
  language,
  currency,
  region,
  timezone,
}) => {
  const languageDefault = useLanguage()
  const {
    currency: currencyDefault,
    origin: originDefault,
    timezone: timezoneDefault,
  } = usePreferences()

  return (
    <>
      <HiddenField name="language" value={language ?? languageDefault} />
      <HiddenField name="currency" value={currency ?? currencyDefault} />
      <HiddenField name="region" value={region ?? originDefault} />
      <HiddenField name="timezone" value={timezone ?? timezoneDefault} />
    </>
  )
}
